import { openDB } from "idb";

const DB_NAME = "spreadsheet";
const STORE = "sheets";

interface CellData {
  value: string;
  format?: {
    bold?: boolean;
    italic?: boolean;
    underline?: boolean;
    fontSize?: string;
    fontFamily?: string;
    fontColor?: string;
    backgroundColor?: string;
    alignment?: string;
    borderStyle?: string;
  };
}

export async function loadSheet(): Promise<CellData[][] | null> {
  const db = await openDB(DB_NAME, 1, {
    upgrade(db) {
      db.createObjectStore(STORE);
    },
  });
  return (await db.get(STORE, "main")) || null;
}

export async function saveSheet(data: CellData[][]) {
  const db = await openDB(DB_NAME, 1, {
    upgrade(db) {
      db.createObjectStore(STORE);
    },
  });
  await db.put(STORE, data, "main");
} 